import { isElementTypeTitle } from '@/common/converter/utils/element'

/**
 * elementList 에서 title element 를 찾아 반환
 * @param elementList
 * @returns {*|string}
 */
export const getTitle = (elementList) => {
  if (!Array.isArray(elementList)) {
    return ''
  }

  const element = elementList?.find(isElementTypeTitle) ?? {}
  const { property } = element

  return property?.text ?? ''
}
